module.exports = "/_next/static/images/stats-line-def7eb6958ab945121cd52732f2c4f98.svg";